var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { LabelStylesRem } from './LabelStyles';
export var LabelExtraLarge = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), LabelStylesRem('extraLarge'));
export var LabelLarge = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), LabelStylesRem('large'));
export var LabelMedium = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), LabelStylesRem('medium'));
export var LabelSmall = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), LabelStylesRem('small'));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
